var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"fullscreen-button",attrs:{"tile":"","large":"","icon":"","color":"grey"},on:{"click":_vm.openFullscreen}},[_c('v-icon',{domProps:{"textContent":_vm._s('mdi-arrow-expand-all')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }